import React, { useState } from "react";
import Input from "../Input/Input";
import classes from "./ContentCard.module.scss";

const ContentCard = ({
  type,
  src,
  title,
  value,
  index,
  setValue,
  handleChange,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div className={classes.contentCard}>
      <div className={classes.contentCard__main}>
        {type === "youtube" || type === "slideshare" ? (
          <iframe
            id="iframe"
            className={classes.contentCard__main__content}
            src={src}
            title={title}
            frameBorder="0"
            allowFullScreen
          />
        ) : type === "mooc" ? (
          <div
            className={classes.contentCard__main__content}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            <img
              src={src}
              alt={title}
              className={
                hover
                  ? classes.contentCard__main__content__thumbnailHover
                  : classes.contentCard__main__content__thumbnail
              }
            />
            {hover && (
              <div
                className={classes.contentCard__main__content__detailsContainer}
              >
                <div
                  className={
                    classes.contentCard__main__content__detailsContainer__detail
                  }
                >
                  Source: {value.MoocCourseSource}
                </div>
                <div
                  className={
                    classes.contentCard__main__content__detailsContainer__detail
                  }
                  title={value.MoocCourseDescription}
                >
                  Description: {value.MoocCourseDescription}
                </div>
                <a
                  href={value.MoocCourseUrl}
                  className={
                    classes.contentCard__main__content__detailsContainer__detail
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  {value.MoocCourseName}
                </a>
              </div>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
      <div
        className={classes.contentCard__details}
        onClick={(e) => {
          e.stopPropagation();
          setValue(`Content.ContentValue${index}`, "");
          handleChange("", value);
        }}
      >
        <div className={classes.contentCard__details__title} title={title}>
          {title}
        </div>
        <Input
          name={`Content.ContentValue${index}`}
          type={"radio"}
          height="2"
          width="2"
          value={value}
          direction="row-reverse"
          onChange={() => {
            setValue(`Content.ContentValue${index}`, "");
            handleChange("", value);
          }}
        />
      </div>
    </div>
  );
};

export default ContentCard;
